/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class PublicationInfoByZone extends DaoModel {
  constructor(guid, sale_zone_name, sale_zone_guid, publication_link) {
    super(guid);
    this.sale_zone_name = sale_zone_name || '';
    this.sale_zone_guid = sale_zone_guid || '';
    this.publication_link = publication_link || '';
  }

  static toInstance(props = {}) {
    return new PublicationInfoByZone(props.guid, props.sale_zone_name, props.sale_zone_guid, props.publication_link);
  }

  serialize() {
    return {
      ...super.serialize(),
      sale_zone_name: this.sale_zone_name,
      sale_zone_guid: this.sale_zone_guid,
      publication_link: this.publication_link
    };
  }
}
